<template>
  <div class="settlement-collection">
    <div class="nav">
      <el-form :model="form" label-width="80px" :inline="true"  class="demo-form-inline flex1">
        <el-form-item label="批次号:">
          <el-input v-model="form.batch" size="mini" placeholder="请输入批次号"></el-input>
        </el-form-item>
        <el-form-item label="运单编号:">
          <el-input v-model="form.Waybill" size="mini" placeholder="请输入运单编号"></el-input>
        </el-form-item>
        <el-form-item label="底盘号:">
          <el-input v-model="form.chassis" size="mini" placeholder="请输入底盘号"></el-input>
        </el-form-item>
        <el-form-item label="委托商:">
          <el-input v-model="form.consignor" size="mini" placeholder="请输入委托商"></el-input>
        </el-form-item>
        <el-form-item label="经销商:">
          <el-input v-model="form.distributor" size="mini" placeholder="请输入经销商"></el-input>
        </el-form-item>
        <el-form-item label="计划日期:">
          <el-date-picker
            v-model="form.planDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="mini"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="运输条款:">
          <el-select v-model="form.transport" filterable size="mini" placeholder="请选择运输条款">
            <el-option label="全部" value=""></el-option>
            <el-option label="公路" value="1"></el-option>
            <el-option label="水路" value="2"></el-option>
            <el-option label="水陆联运" value="3"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否生成对账单:" label-width="130px">
          <el-select v-model="form.whetherBill" filterable size="mini" placeholder="请选择是否生成对账单">
            <el-option label="全部" value=""></el-option>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
          <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
          <el-button size="small" type="primary" @click="addBtn">生成对账单</el-button>
        </el-form-item>

      </el-form>
    </div>
    <el-row>
      <el-col :span="12" style="text-align: left;">
        <template>
          <el-checkbox-group v-model="checkList">
            <el-checkbox label="公路"></el-checkbox>
            <el-checkbox label="水路"></el-checkbox>
            <el-checkbox label="水陆联运"></el-checkbox>
          </el-checkbox-group>
        </template>
      </el-col>
      <el-col :span="12" style="text-align: end;" class="exportButton">
        <span @click="importClick">导入生成对账单</span>
        <span>导出数据</span>
      </el-col>
    </el-row>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          tooltip-effect="dark"
          ref="multipleTable"
          @select="handleCurrentChange"
           :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
        >
          <el-table-column  type="selection" align="center" width="70px">

          </el-table-column>
          <el-table-column prop="batch" label="批次号" align="center"/>
          <el-table-column prop="Waybill" label="运单编号" align="center"/>
          <el-table-column prop="chassis" label="底盘号" align="center"/>
          <el-table-column prop="brand" label="品牌" align="center"/>
          <el-table-column prop="model" label="型号" align="center"/>
          <el-table-column prop="consignor" label="委托商" align="center"/>
          <el-table-column prop="distributor" label="经销商" align="center"/>
          <el-table-column prop="planDate" label="计划日期" align="center"/>
          <el-table-column prop="referred" label="发运日期" align="center"/>
          <el-table-column prop="referred" label="交车日期" align="center"/>
          <el-table-column prop="transport" label="运输条款" align="center"/>
          <el-table-column prop="referred" label="含税费用" align="center"/>
          <el-table-column prop="referred" label="税后费用" align="center"/>
          <el-table-column prop="whetherBill" label="是否生成对账单" align="center"/>
        </el-table>
      </div>
      <div class="paginationContainer">
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          :current-page.sync="form.page"
          :page-size="form.rows"
        />
      </div>
    </div>
    <el-dialog title="生成对账单" :visible.sync="addflag"  width='1250px' center >
      <div class="add">
        <div class="baseInfo">
          <div class="baseInfoContent">
            <div style="display: flex;align-items: center;margin-bottom: 20px">
              <div style="font-weight: 700;">标题：</div>
              <el-input size="mini" v-model="billTitle" style="width: 200px"></el-input>
              <div style="margin-left: 20px">
                <el-button size="mini" type="primary"  @click="addClick">确认</el-button>
                <el-button size="mini" type="info" @click="dialogClose">取消</el-button>
              </div>
            </div>

            <el-table
              v-loading="checkLoad"
              :data="checkTableData"
              style="width: 100%"
              border
              :summary-method="getSummaries"
              show-summary
              :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}"
            >
<!--              <el-table-column label="序号" align="center" width="50px">-->
<!--                <div slot-scope="scope">{{scope.$index+1}}</div>-->
<!--              </el-table-column>-->
              <el-table-column prop="batch" label="批次号" align="center"/>
              <el-table-column prop="Waybill" label="运单编号" align="center"/>
              <el-table-column prop="chassis" label="底盘号" align="center"/>
              <el-table-column prop="brand" label="品牌" align="center"/>
              <el-table-column prop="model" label="型号" align="center"/>
              <el-table-column prop="consignor" label="委托商" align="center"/>
              <el-table-column prop="distributor" label="经销商" align="center"/>
              <el-table-column prop="planDate" label="计划日期" align="center"/>
              <el-table-column prop="referred" label="发运日期" align="center"/>
              <el-table-column prop="referred" label="交车日期" align="center"/>
              <el-table-column prop="transport" label="运输条款" align="center"/>
              <el-table-column prop="included" label="含税费用" align="center" />
              <el-table-column prop="afterTax" label="税后费用" align="center" />
              <el-table-column  label="操作" align="center">
                <template slot-scope="scope">
                  <div class="iconError">
                    <i class="el-icon-error" @click="deleteClick(scope.$index)"></i>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

        </div>

      </div>
    </el-dialog>

    <el-dialog title="生成对账单" :visible.sync="importShow" width='1250px' center>
      <div class="importBill">
        <div class="baseInfo">
          <div class="baseInfoContent">
            <div style="display: flex;align-items: center;margin-bottom: 10px">
              <div style="font-weight: 700;">标题：</div>
              <el-input size="mini" v-model="billTitle" style="width: 200px"></el-input>
              <div style="margin-left: 20px">
                <el-button size="mini" type="primary"  @click="addClick">确认</el-button>
                <el-button size="mini" type="info" @click="dialogClose">取消</el-button>
              </div>

            </div>
            <el-row style="margin-bottom: 10px">
              <el-col :span="24" style="font-size: 14px;color: #606266;font-weight: 700;">合计含税费用:</el-col>
            </el-row>
            <el-row style="margin-bottom: 10px">
              <el-col :span="24" style="font-size: 14px;color: #606266;font-weight: 700;">合计税后费用:</el-col>
            </el-row>

            <el-table
              v-loading="checkLoad"
              :data="checkTableData2"
              style="width: 100%"
              border
              :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}"
              :row-class-name="tableRowClassName"
            >
              <!--              <el-table-column label="序号" align="center" width="50px">-->
              <!--                <div slot-scope="scope">{{scope.$index+1}}</div>-->
              <!--              </el-table-column>-->
              <el-table-column prop="batch" label="批次号" align="center"/>
              <el-table-column prop="Waybill" label="运单编号" align="center"/>
              <el-table-column prop="chassis" label="底盘号" align="center"/>
              <el-table-column prop="brand" label="品牌" align="center"/>
              <el-table-column prop="model" label="型号" align="center"/>
              <el-table-column prop="consignor" label="委托商" align="center"/>
              <el-table-column prop="distributor" label="经销商" align="center"/>
              <el-table-column prop="planDate" label="计划日期" align="center"/>
              <el-table-column prop="referred" label="发运日期" align="center"/>
              <el-table-column prop="referred" label="交车日期" align="center"/>
              <el-table-column prop="transport" label="运输条款" align="center"/>
              <el-table-column prop="included" label="含税费用" align="center" />
              <el-table-column prop="afterTax" label="税后费用" align="center" />
              <el-table-column prop="remark" label="说明" align="center" />
              <el-table-column  label="操作" align="center">
                <template slot-scope="scope">
                  <div class="iconError">
                    <i class="el-icon-error" @click="deleteClick(scope.$index)"></i>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>



        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line"/>
            <span>未生成车辆</span>
          </div>
          <div class="operationTable">
            <el-table
              v-loading="checkLoad"
              :data="notTableData"
              style="width: 80%"
              border
              :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}"
            >
              <el-table-column label="序号" align="center" width="50px">
                <div slot-scope="scope">{{scope.$index+1}}</div>
              </el-table-column>
              <el-table-column prop="batch" label="批次号" align="center"/>
<!--              <el-table-column prop="Waybill" label="运单编号" align="center"/>-->
              <el-table-column prop="chassis" label="底盘号" align="center"/>
              <el-table-column prop="brand" label="品牌" align="center"/>
              <el-table-column prop="model" label="型号" align="center"/>
<!--              <el-table-column prop="consignor" label="委托商" align="center"/>-->
<!--              <el-table-column prop="distributor" label="经销商" align="center"/>-->
<!--              <el-table-column prop="planDate" label="计划日期" align="center"/>-->
<!--              <el-table-column prop="referred" label="发运日期" align="center"/>-->
<!--              <el-table-column prop="referred" label="交车日期" align="center"/>-->
              <el-table-column prop="transport" label="运输条款" align="center"/>
              <el-table-column prop="included" label="含税费用" align="center" />
              <el-table-column prop="afterTax" label="税后费用" align="center" />
              <el-table-column prop="remark" label="说明" align="center" />
              <el-table-column  label="操作" align="center">
                <template slot-scope="scope">
                  <el-button size="mini" type="primary">添加</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>



      </div>

    </el-dialog>

<!--    <div class="operation">-->
<!--      <div class="operationTitle">-->
<!--        <div class="line"/>-->
<!--        <span>审核信息</span>-->
<!--      </div>-->
<!--      <div class="operationTable">-->
<!--        <steps :step-data="stepData" :step-state="stepState"/>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
  import {
    baseUrl,
    baseImgUrl
  } from "@/config/env";
  import uploadImg from "@/components/uploadImg";
  import divBorder from "@/components/divBorder";
  import steps from "@/components/steps";
  export default {
    components: {
      uploadImg,
      divBorder,
      steps
    },

    data() {
      return {
        form:{
          batch:"",//批次号
          Waybill:'',//运单编号
          chassis:'',//底盘号
          consignor:'',//委托商
          distributor:'',//经销商
          planDate:'',//计划日期
          transport:'',//运输条款
          whetherBill:'',//是否生成账单
          page:1,
          rows:10,
        },
        total:0,
        tableLoad:false,
        TableDatas:[
          {
            batch:"",//批次号
            Waybill:'',//运单编号
            chassis:'',//底盘号
            consignor:'',//委托商
            distributor:'',//经销商
            planDate:'',//计划日期
            transport:'',//运输条款
            whetherBill:'',//是否生成账单
            brand:'',
            model:''
          },

        ],
        checkList:[],
        billTitle:'',
        checkLoad:false,
        checkTableData:[
          {
            batch:"4",//批次号
            Waybill:'',//运单编号
            chassis:'对方答复',//底盘号
            consignor:'',//委托商
            distributor:'',//经销商
            planDate:'',//计划日期
            transport:'',//运输条款
            included:'100',//含税
            afterTax:'200',//税后
            brand:'',
            model:''
          },
          {
            batch:"",//批次号
            Waybill:'',//运单编号
            chassis:'',//底盘号
            consignor:'',//委托商
            distributor:'',//经销商
            planDate:'',//计划日期
            transport:'',//运输条款
            included:'300',//含税
            afterTax:'300',//税后
            brand:'',
            model:''
          },
        ],
        checkTableData2:[
          {
            batch:"4",//批次号
            Waybill:'',//运单编号
            chassis:'对方答复',//底盘号
            consignor:'',//委托商
            distributor:'',//经销商
            planDate:'',//计划日期
            transport:'',//运输条款
            included:'100',//含税
            afterTax:'200',//税后
            remark:'相等',//说明
            brand:'',
            model:''
          },
          {
            batch:"",//批次号
            Waybill:'',//运单编号
            chassis:'',//底盘号
            consignor:'',//委托商
            distributor:'',//经销商
            planDate:'',//计划日期
            transport:'',//运输条款
            included:'300',//含税
            afterTax:'300',//税后
            remark:'价格异常',//说明
            brand:'',
            model:''
          },
        ],
        notTableData:[
          {
            batch:"4",//批次号
            Waybill:'',//运单编号
            chassis:'对方答复',//底盘号
            consignor:'',//委托商
            distributor:'',//经销商
            planDate:'',//计划日期
            transport:'',//运输条款
            included:'100',//含税
            afterTax:'200',//税后
            brand:'',
            model:''
          },
          {
            batch:"",//批次号
            Waybill:'',//运单编号
            chassis:'',//底盘号
            consignor:'',//委托商
            distributor:'',//经销商
            planDate:'',//计划日期
            transport:'',//运输条款
            included:'300',//含税
            afterTax:'300',//税后
            brand:'',
            model:''
          },
        ],
        importShow:true,
        stepData:[
          {title:'张三发起',time:'2021-9-30 14:09:23',state:'',remark:''},
          {title:'财务部 张三通过',time:'2021-9-30 14:09:23',state:'success',remark:'原因xxxxxx'},
          {title:'技术部 李四拒绝',time:'2021-9-30 14:09:23',state:'failure',remark:'原因xxxxxx'},
          {title:'张三重新发起',time:'2021-9-30 14:09:23',state:'',remark:''},
        ],

        addflag:false,
        rules:{
          plan:{required: true, message: ' ', trigger: 'blur'},
          name:[
            { required: true, message: '请输入业务名称', trigger: 'blur' },
            { min: 3, max: 9, message: '长度在 3 到 9 个字符', trigger: 'blur' }
          ],
          content:{required: true, message: '请输入评审需求', trigger: 'blur'},
          type: { required: true, message: '请选择评审类型', trigger: 'blur' },
          img:{ required: true, message: '请选择合同照片', trigger: 'blur' },

        }

      };

    },
    computed:{
      stepState(){
        return function(state){
          switch(state) {
            case '':
              return 'wait'
            case 'success':
              return 'success'
            case 'failure':
              return 'error'
          }
        };
      },
      sumIncluded(){

      }
    },
    methods: {
      init(){

      },
      addBtn(){
        this.addflag = true
      },
      searchBtn(){
        this.page = 1
      },
      resetBtn(){
        for (const argumentsKey in this.form) {
          this.form[argumentsKey] = ""
        }
        this.form.page = 1
        this.form.rows = 10

      },
      contractSizeChange(row){
        this.form.rows=row;
      },
      contractCurrentChange(page){
        this.form.page=page;
      },

      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index)=>{
          if (index===0){
            sums[index] = "合计";
          }else if (index >= 11){
            const values = data.map((item) => Number(item[column.property]));
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                return prev+curr;
              },0)


            }
            console.log(column)
          }
        })
        return sums
      },
      deleteClick(index){
        this.checkTableData2.splice(index,1)
      },
      // 导入
      importClick(index,row){
        this.importShow = true
      },
      tableRowClassName({row}) {
        if (row.remark==='价格异常') return 'ui-warning-row';
        else return '';
      },
      handleCurrentChange(val){
        console.log(val)
      }

    },
  };
</script>



<style lang="scss" scoped>
  .settlement-collection{
    width:100%;
    padding:20px 15px 0 25px;
    height: 100%;
    .exportButton{
      span{
        color: rgba(51, 136, 255, 1);
        text-decoration: underline;
        margin-right: 10px;
        &:hover{
          cursor: pointer;
        }
      }
    }
    ::v-deep .el-table__header .has-gutter tr .el-table-column--selection .cell .el-checkbox::after{
      color: #606266;
      content: "全选";
      font-size: 12px;
      margin-left: 2px;

    }
    .nav{
      width:100%;
      display: flex;
      align-items: center;
      overflow: hidden;
      .flex1{
        flex: 1;
      }
      .el-input{
        width: 150px;
      }
      .el-select{
        width: 150px;
      }
      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }
    ::v-deep .importBill{
      width: 100%;
      padding: 10px 0 20px 20px;
      .line{
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }
      .line +span{
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }
      .el-table td, .el-table th{
        padding:0;
      }
      .baseInfo{
        display: flex;
        flex-direction: column;
        &Title{
          display:flex;
          align-items:flex-end;
          p{
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }
        &Content{
          display:flex;
          flex-direction: column;
          justify-content: space-between;
          /*padding:20px 23px 0 23px;*/
          padding-right: 20px;
          margin-top: 20px;
          font-size: 14px;

          .el-table .ui-warning-row {
            background-color: #fef0f0!important;
          }
          .el-table--enable-row-hover .el-table__body tr.ui-warning-row:hover>td{
            background-color: #fef0f0!important;
          }
          .el-table .ui-warning-row .cell{
            color: red;
          }
          .cell{
            font-size: 10px;
            padding:0;
          }
          .iconError{
            font-size: 15px;
            i:hover{
              color: #00e1ff;
            }
          }


        }
      }
      .operation{
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        &Title{
          display:flex;
          align-items:flex-end;
          p{
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }
        .cell{
          font-size: 10px;
          padding:0;
        }
        &Table{
          width:100%;
          margin-top: 10px;
          padding-right: 20px;
          .el-button--mini{
            padding: 4px 4px;
          }
        }
      }
    }
    ::v-deep .add{


      font-weight: 700;
      width: 100%;

      .baseInfo{
        display: flex;
        flex-direction: column;

        &Input{
          display: flex;
          height: 30px;
          line-height: 30px
        }
        &Content{
          display:flex;
          flex-direction: column;
          justify-content: space-between;
          padding:20px 23px 0 23px;
          font-size: 14px;
          .el-table td, .el-table th{
            padding:0;
          }
          .iconError{
            font-size: 20px;
            i:hover{
              color: #00e1ff;
            }
          }
          .yang{
            .el-form-item{

              margin-bottom:15px;

              .el-form-item__label{
                /*width: 150px !important;*/
                /*color: #060606;*/
              }
              .el-input{
                width: 430px;
              }
              .el-textarea{
                width: 250px;

              }
            }

          }

        }
      }

      .btnContainer{
        width:100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;
        button{
          margin: 0 15px;
        }
      }
    }
    ::v-deep{

      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #FFFFFF;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
        overflow: auto;
        max-height: 75vh;
        color: #606266;
      }

    }

  }

</style>
